import { Container, Row, Col } from "react-bootstrap"
import { Rest, TConfigurator, TMarket } from "../../service/rest"
import { isExtendet } from "../../settings"
import { TDropdownSelectedItem } from "../ConfigDropdown/ConfigDropdown"
import { Configurator } from "../configurator/configurator"
import "./style.css"

type TMarketProps = {
    market: TMarket,
    filterType: TDropdownSelectedItem[],
    filterLive: TDropdownSelectedItem[],
    filterFeature: TDropdownSelectedItem[]
}

export const Market = ({market, filterType, filterLive, filterFeature}:TMarketProps) => {

    const isConfiguratorVisible = (configurator:TConfigurator) => {
        var show = false;

        if ( (configurator.extern && !configurator.hidden) || isExtendet()){
            show = true;
        } else {
            return show;
        }
        

        for (var filter of filterType){
            if(filter.selected && configurator.additionalData && configurator.additionalData.type === filter.key){
                show = true;
                break;
            } else if (filter.selected) {
                show = false;
            }
        }

        if (!show){
            return show
        }

        for (var filter of filterLive){
            if(filter.selected && configurator.additionalData && configurator.additionalData.status === filter.key){
                show = true;
                break;
            } else if (filter.selected) {
                show = false;
            }
        }

        if (!show){
            return show;
        }

        for (var filter of filterFeature){
            if(filter.selected && configurator.additionalData && configurator.additionalData.features.includes(filter.key)){
                show = true;
                break;
            } else if (filter.selected){
                show = false;
            }
        }

        return show
    }

    const markets = market.list ? market.list.filter(configurator => isConfiguratorVisible(configurator)).map(configurator => <Configurator key={`${configurator.settings.orgID+Rest.getTranslatedText(configurator.configuratorName)}-${Math.random()}`} configurator={configurator}/>) : [];

    if (markets.length == 0){
        return null;
    }

    return (
        <>
            <Container>
                <Row>
                    <Col xs={12} sm={12} md={8}>
                        <h1 className="country">{Rest.getTranslatedText(market.description)}</h1>
                    </Col>
                </Row>
            </Container>
            
            <div className="configuratorContainer">
                <Container>
                    <Row>
                        {market.list && markets}
                    </Row>
                </Container>
            </div>
        </>
    )
}